<template>
<div class="forgot-password-container">
    <div class="logo-container">
        <img :src="require('../assets/img/cuelistBLACK.png')" alt="Cuelist Logo" class="logo"/>
    </div>
    <div class="forgot-password-card">

        <div v-if="!sent" class="form-container">
            <h2>Reset Your Password</h2>
            <p class="description">Enter your email address and we'll send you a link to reset your password.</p>
            
            <form @submit.prevent="submit" class="forgot-form">
                <md-input-container :class="{'md-input-invalid': emailError}">
                    <label for="forgot-email-input">Email Address</label>
                    <md-input 
                        id="forgot-email-input"
                        v-model="email" 
                        type="email"
                        :disabled="loading"
                        @blur="validateEmail"
                    ></md-input>
                    <span class="md-error" v-if="emailError">{{ message }}</span>
                </md-input-container>

                <div class="button-group">
                    <md-button 
                        class="md-raised md-primary submit-button" 
                        :disabled="!isValid || loading"
                        @click="submit"
                    >
                        <md-spinner v-if="loading" :md-size="20" class="md-accent"></md-spinner>
                        <span v-else>Send Reset Link</span>
                    </md-button>
                    
                    <md-button 
                        class="back-button" 
                        @click="back"
                        :disabled="loading"
                    >
                        Back to Login
                    </md-button>
                </div>
            </form>
        </div>

        <div v-else class="success-message">
            <md-icon class="success-icon">check_circle</md-icon>
            <h3>Email Sent!</h3>
            <p>We've sent a password reset link to your email address.</p>
            <p class="redirect-message">Redirecting to login...</p>
        </div>
    </div>
    <core-footer/>
</div>
</template>

<script>
import firebase from 'firebase/app';
import { mapGetters } from 'vuex';
import CoreFooter from '@/components/core/footer';

const emailRegex = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;

const ForgotView = {
    name: 'ForgotView',
    components: {
        'core-footer': CoreFooter
    },
    data() {
        return {
            email: '',
            sent: false,
            message: '',
            loading: false,
            emailError: false
        };
    },
    computed: {
        ...mapGetters(['userByEmail']),
        isValid() {
            return emailRegex.test(this.email);
        }
    },
    methods: {
        validateEmail() {
            if (!this.email) {
                this.message = 'Email is required';
                this.emailError = true;
            } else {
                this.message = '';
                this.emailError = false;
            }
        },
        submit() {
            this.message = '';
            firebase.auth().sendPasswordResetEmail(this.email).then(() => {
                this.sent = !this.sent;
                setTimeout(() => {
                    this.$router.replace('/login');
                }, 1000);
            }).catch((err) => {
                this.message = err.message;
            });
        },
        emailError() {
            return this.message !== '';
        },
        getErrorMessage(errorCode) {
            switch (errorCode) {
            case 'auth/too-many-requests':
                return 'Too many attempts. Please try again later.';
            case 'auth/network-request-failed':
                return 'Network error. Please check your connection.';
            default:
                return 'An error occurred. Please try again.';
            }
        },
        back() {
            this.$router.replace('/login');
        }
    }
};

export default ForgotView;
</script>

<style lang="scss" scoped>
.forgot-password-container {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
    padding: 20px;
}

.forgot-password-card {
    background: white;
    padding: 40px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 500px;
    margin: 20px auto;
}

.logo-container {
    text-align: center;
    margin-bottom: 30px;
    
    .logo {
        max-width: 350px;
        height: auto;
    }
}

.form-container {
    h2 {
        text-align: center;
        margin-bottom: 10px;
        color: #333;
    }

    .description {
        text-align: center;
        color: #666;
        margin-bottom: 30px;
    }
}

.forgot-form {
    .md-input-container {
        margin-bottom: 20px;
    }
}

.button-group {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;

    .submit-button {
        width: 100%;
        height: 48px;
        font-size: 16px;
        text-transform: none;
        margin: 6px 0px;
    }

    .back-button {
        width: 100%;
        text-transform: none;
        color: #666;
        margin: 6px 0px;
    }
}

.success-message {
    text-align: center;
    padding: 20px;

    .success-icon {
        font-size: 48px;
        color: #4CAF50;
        margin-bottom: 20px;
    }

    h3 {
        color: #333;
        margin-bottom: 10px;
    }

    p {
        color: #666;
        margin-bottom: 5px;
    }

    .redirect-message {
        color: #999;
        font-size: 14px;
        margin-top: 20px;
    }
}

.md-error {
    color: #f44336;
    font-size: 12px;
    margin-top: 5px;
}
</style>


// WEBPACK FOOTER //
// forgot.vue?7822d775